import { Components, Theme, svgIconClasses } from '@mui/material';
import { TypographyStyles } from '../typography';
import { Spacing2 } from '../spacing';

export const MuiFormHelperText: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: {
      ...TypographyStyles.body3,
      marginLeft: 0,
      marginTop: Spacing2,

      [`.${svgIconClasses.root}`]: {
        width: 16,
        height: 16,
        position: 'relative',
        top: 3,
      },
    },
  },
};
